// extracted by mini-css-extract-plugin
export default {"price":"BasketProductPrice-41pgl__price"};